import ImagePopup from "./ImagePopup";

export default ImagePopup;
